import React, { Component } from 'react';
import { connect } from 'react-redux'
import ReactAutocomplete from 'react-autocomplete';
import * as Actions from './SelectClubActions'
import PropTypes from 'prop-types';

import {entityGet} from '../entity/Entity';

import './ClubList.css';


class ClubList extends Component {

  constructor(props) {
      super(props);
      this.fetchedClubs = false;
      this.state = {
        clubText: ''
      }

      if (!this.props.club.clubs) this.getClubs();
      this.maxItems =  this.props.maxItems ? this.props.maxItems : 10;
      this.includeDissolved = this.props.includeDissolved ? this.props.includeDissolved : false;
  }

  getClubs() {
    if (this.fetchedClubs) return  false;
    this.fetchedClubs = true;

    const parameters = {'UnionId': this.props.unionid, 'IncludeDissolved': true};
    this.props.fetchingClubs()
    entityGet("ClubListBasic", parameters, this.props.fetchClubsSuccess, this.props.fetchClubsFailure);

  }

  render() {
    if (!this.props.club.clubs) {
      return <div> <p>Bezig met laden! </p></div>
    }

    var clubs = (this.props.club.clubs) ? this.props.club.clubs: [];
    var clubsMatched = clubs.filter(e => {
      if (!this.state.clubText) return false;
      var match =e.Name.toLowerCase().indexOf(this.state.clubText.toLowerCase()) > -1;
      if (match && !this.includeDissolved) {
        return !e.Dissolved
      }
      return match;
    });


    clubsMatched = clubsMatched.slice(0,this.maxItems); // limit matches

    return (
      <ReactAutocomplete name="priorclub" id="PriorClub"
        items={clubsMatched}
        value={this.state.clubText}
        getItemValue={item => item.Name}
        onChange={(event, clubText) => this.setState({ clubText })}
        renderItem={(item, highlighted) => {
          var dissolvedText = item.Dissolved ? ' (opgeheven)' : '';
          return (<div
                key={item.ClubId}
                style={{ backgroundColor: highlighted ? '#ececec' : 'transparent'}}
                className="autocompleteItem box"
              >
              <img src={item.Logo} alt="" className="ClubListLogo"/>
              <span className="ClubListText">{item.Name} {dissolvedText}</span>
              <div className="clear" />
          </div>);
        }}
        inputProps={{ style: { height: '60px', width: '100%' }, id: 'clubs-autocomplete', placeholder: 'Begin met typen om een club te kiezen' }}
        wrapperStyle={{ position: 'relative', width: '100%' }}
        menuStyle={{ top: '35px', left: 0,maxHeight: '10%'  }}
        onSelect={ (clubText, item) => {this.setState({ clubText }); this.props.onclick(item.ClubId)}}
      />
    )
  }
}

ClubList.propTypes = {
  unionid: PropTypes.string.isRequired,
  onclick: PropTypes.func,
  includeDissolved: PropTypes.bool,
  maxItems: PropTypes.number
};

const mapStateToProps = state => ({
  club: state.club
})

const mapDispatchToProps = dispatch => ({
  fetchingClubs: () => dispatch(Actions.fetchingClubs()),
  fetchClubsSuccess: (data) => dispatch(Actions.fetchClubsSuccess(data['ClubListBasic'])),
  fetchClubsFailure: () => dispatch(Actions.fetchClubsFailure())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClubList)



// WEBPACK FOOTER //
// ./src/club/ClubList.jsx